import React, { FC, useState } from "react";
import CheckboxListField from "../checkbox-list-field/checkbox-list-field";
import Label from "../label/label";
import { CanGoBack } from "../../models/CanGoBack";
import { useLocale } from "../../contexts/localeContext";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import { CanGoNext } from "../../models/CanGoNext";
import { useFormikContext } from "formik";
import { BackButton } from "../fields/buttons/back-button";

interface FieldsFormProps extends CanGoBack, CanGoNext {
    options?: any;
    setSideBarStepDescription?: (newDescription) => void;
    setShowFieldsModal?: any
    onDelete?: any
    customDelete?: any
}

const FieldsForm: FC<FieldsFormProps> = ({ customDelete, onDelete, setShowFieldsModal, onBack, onNext, options, setSideBarStepDescription = () => { } }) => {
    const { translate } = useLocale();
    const { values } = useFormikContext();

    return (<div className="flex flex-col pt-3 pr-3 h-full relative" style={{ height: "501px" }}>
        <div className="overflow-y-auto" style={{ height: '87%' }}>
            <Label htmlFor="fields"
                className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.fields)}:</Label>
            <CheckboxListField customDelete={customDelete} onDelete={onDelete} compact={true} name="fields" options={options} allowReinitialise scrollable={false} ></CheckboxListField>
        </div>
        <div className="flex flex-row justify-between absolute bottom-0 right-0 pr-3 pb-3 w-full">
            <button
                onClick={() => setShowFieldsModal(true)}
                className="bg-lime text-white font-bold py-1 px-5 rounded-full "
                type="button"  >
                {translate.byKey(TranslationKeys.addField)}
            </button>
        </div>
        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
            <div className="flex flex-row justify-end mt-4 pl-3"><BackButton onClick={onBack} /></div>
            <div className="flex flex-row justify-end mt-4 pl-3">
                <button
                    className="secondary secondary-enabled py-1 px-5"
                    type="button" onClick={(e) => { onNext(e); setSideBarStepDescription(`${(values as any)['fields'].length} fields selected`); }} >
                    {translate.byKey(TranslationKeys.next)}
                </button>
            </div>
        </div>
    </div>)
}

export default FieldsForm;
